module.exports = {
  footerText: 'Copyright Company Name © 2018',
  cookieDomain: process.env.NODE_ENV === 'development' ? '127.0.0.1' : 'belkapost.ru',
};
